import type { Banner, Container } from '../../schema/spaces/ecommerce-petsmart';
import type { Transforms } from '../../utils/map-entries';
import { transformBanner } from './banner/transform';
import { transformContainer } from './container/transform';

export const transforms: Transforms = {
    // is H1 is temporary to support legacy rendering
    banner: entry => transformBanner(entry as Banner, { headingTagName: entry.fields.isH1 === true ? 'h1' : 'h2' }),
    container: (entry, map) => transformContainer(entry as Container, map),
};
